import { useEffect, useRef } from 'react';
import { useSessionContext } from 'supertokens-auth-react/recipe/session';
import { getApiUrl } from '../config/env';

interface ExtendedSessionContextType {
  doesSessionExist: boolean;
  userId?: string;
  loading: boolean;
}

/**
 * Hook to track user login events and call the backend
 * This is used to trigger welcome notifications for new users
 */
export function useLoginTracker() {
  const session = useSessionContext() as ExtendedSessionContextType;
  const hasTrackedLogin = useRef(false);

  useEffect(() => {
    // Only proceed if we have confirmed a session exists and haven't tracked this login yet
    if (session.loading || !session.doesSessionExist || hasTrackedLogin.current) {
      return;
    }

    const trackLogin = async () => {
      try {
        console.log('Tracking login event...');
        const response = await fetch(getApiUrl('/api/users/login-event'), {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          console.error('Failed to track login event:', response.status);
        } else {
          console.log('Login tracked successfully');
        }
      } catch (error) {
        console.error('Error tracking login event:', error);
      }
      
      // Mark that we've tracked this login
      hasTrackedLogin.current = true;
    };

    // Call the login tracker
    trackLogin();
  }, [session.doesSessionExist, session.loading]);
} 